import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCustomerProfile } from './api';

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ts_customer_token');
    if (token) {
      getCustomerProfile()
        .then(data => setCustomer(data.customer))
        .catch(() => localStorage.removeItem('ts_customer_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const loginCustomer = (token, customerData) => {
    localStorage.setItem('ts_customer_token', token);
    setCustomer(customerData);
  };

  const logoutCustomer = () => {
    localStorage.removeItem('ts_customer_token');
    setCustomer(null);
  };

  return (
    <CustomerAuthContext.Provider value={{ customer, loading, loginCustomer, logoutCustomer }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export function useCustomerAuth() {
  return useContext(CustomerAuthContext);
}
